import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoft365RegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m13.508 2.652-.143.086a5 5 0 0 0-.641.46l.412-.29h3.5l.637 4.818-3.182 3.182-3.182 2.212v2.55c0 1.781.931 3.433 2.455 4.356l3.35 2.027-7.078 4.129H8.271l-2.544-1.54a5.09 5.09 0 0 1-2.455-4.356V11.71c0-1.781.932-3.434 2.457-4.356l7.636-4.62z",
			fill: "url(#paint0_radial_9758_1249)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m13.508 2.652-.143.086a5 5 0 0 0-.641.46l.412-.29h3.5l.637 4.818-3.182 3.182-3.182 2.212v2.55c0 1.781.931 3.433 2.455 4.356l3.35 2.027-7.078 4.129H8.271l-2.544-1.54a5.09 5.09 0 0 1-2.455-4.356V11.71c0-1.781.932-3.434 2.457-4.356l7.636-4.62z",
			fill: "url(#paint1_linear_9758_1249)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.091 12.817v2.852a5.09 5.09 0 0 1-2.454 4.355L11 24.646a5.09 5.09 0 0 1-5.096.103l7.46 4.515a5.09 5.09 0 0 0 5.273 0l7.636-4.622a5.09 5.09 0 0 0 2.455-4.356v-2.06l-.636-.954z",
			fill: "url(#paint2_radial_9758_1249)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.091 12.817v2.852a5.09 5.09 0 0 1-2.454 4.355L11 24.646a5.09 5.09 0 0 1-5.096.103l7.46 4.515a5.09 5.09 0 0 0 5.273 0l7.636-4.622a5.09 5.09 0 0 0 2.455-4.356v-2.06l-.636-.954z",
			fill: "url(#paint3_linear_9758_1249)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m26.272 7.354-7.637-4.62a5.09 5.09 0 0 0-5.118-.087l-.152.091a5.09 5.09 0 0 0-2.456 4.357v6.035l2.456-1.486a5.09 5.09 0 0 1 5.27 0l7.637 4.62a5.09 5.09 0 0 1 2.453 4.19l.003-.168V11.71a5.09 5.09 0 0 0-2.456-4.356",
			fill: "url(#paint4_radial_9758_1249)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m26.272 7.354-7.637-4.62a5.09 5.09 0 0 0-5.118-.087l-.152.091a5.09 5.09 0 0 0-2.456 4.357v6.035l2.456-1.486a5.09 5.09 0 0 1 5.27 0l7.637 4.62a5.09 5.09 0 0 1 2.453 4.19l.003-.168V11.71a5.09 5.09 0 0 0-2.456-4.356",
			fill: "url(#paint5_linear_9758_1249)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_9758_1249",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(110.528 3.307 7.843)scale(21.2336 37.0357)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .064,
					stopColor: "#ae7fe2"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0078d4"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_9758_1249",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(-8.367 166.774 -38.41)scale(19.7601 13.0529)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .134,
					stopColor: "#d59dff"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5e438f"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint4_radial_9758_1249",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "rotate(194.228 14.525 7.12)scale(15.8606 26.6999)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .058,
					stopColor: "#50e6ff"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#436dcd"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_9758_1249",
				x1: 11.871,
				y1: 24.825,
				x2: 8.842,
				y2: 19.585,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#114a8b" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0078d4",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_9758_1249",
				x1: 26.41,
				y1: 16.875,
				x2: 23.163,
				y2: 21.531,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#493474" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#8c66ba",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_9758_1249",
				x1: 11.53,
				y1: 2.671,
				x2: 16.31,
				y2: 2.671,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#2d3f80" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#436dcd",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgMicrosoft365RegularIcon;
